const findImageFromList = (image, images) => {
  let res;
  if (!images) return;
  images.forEach((img, i) => {
    if (image === img.url) res = { ...img, pos: i };
  });
  return res;
};

module.exports = { findImageFromList };
